import { Component, inject, signal } from '@angular/core';
import {
  GcInputFieldComponent,
  GcLoadingSpinnerComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { FeedbackAlertService } from '../../../../feedback-alert/service/feedback-alert.service';
import { SaveButtonsComponent } from '../../../report-inputs/components/save-buttons/save-buttons.component';
import { ReportCommentService } from '../../../service/reports/comment/report-comment.service';

@Component({
  selector: 'app-report-comment',
  imports: [
    GcInputFieldComponent,
    SaveButtonsComponent,
    GcLoadingSpinnerComponent,
    IpoTranslatePipe,
  ],
  templateUrl: './report-comment.component.html',
  styleUrl: './report-comment.component.scss',
})
export class ReportCommentComponent {
  private readonly commentService = inject(ReportCommentService);
  private readonly feedbackAlert = inject(FeedbackAlertService);

  comment = this.commentService.reportComment;
  commentMutation = this.commentService.updateV3ReportComment$({
    onSuccess: () => {
      this.displayButtons.set(false);
    },
    onError: () => {
      this.displayButtons.set(true);
    },
  });

  displayButtons = signal(false);

  handleOnChangeInput(comment: string): void {
    this.displayButtons.set(true);
    this.commentService.onCommentChange(comment);
  }

  handleCancelEditMode = (): void => {
    this.commentService.resetComment();
    this.displayButtons.set(false);
  };

  handleUpdateComment = (): void => {
    this.displayButtons.set(false);
    this.commentMutation.mutate();
  };
}
